import React, { type FC } from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Glyph, InputIconContainer } from "@edreamsodigeo/prisma-design-system";

import type { InputPasswordIconProps } from "./contract";

const InputPasswordIcon: FC<InputPasswordIconProps> = (props) => {
  const { t } = useTranslation();

  return (
    <InputIconContainer {...props}>
      {props?.type === "password" ? (
        <Glyph
          category="UIActions"
          name="EyeOff"
          size="medium"
          color="neutral.80"
          aria-label={t("auth.form.password.field.show")}
        />
      ) : (
        <Glyph
          category="UIActions"
          name="EyeOn"
          size="medium"
          color="neutral.80"
          aria-label={t("auth.form.password.field.hide")}
        />
      )}
    </InputIconContainer>
  );
};

export default InputPasswordIcon;
